<template>
	<section id="page-not-found">
		<h2>Page not found</h2>
	</section>
</template>

<script>
export default {
	name: 'PageNotFound'
}
</script>

<style lang="scss" scoped>
	#page-not-found {
		h2 {
			color: tomato;
		}
	}
</style>
